import axios from 'axios';
import authService from '../../../components/api-authorization/AuthorizeService';
import { VNEXT_BASE_URL } from 'utils/Constants';

const surveyClient = axios.create({
  baseURL: `${VNEXT_BASE_URL}survey/v1`,
  headers: {
    'Content-Type': 'application/json',
  },
});

surveyClient.interceptors.request.use(async (config) => {
  const token = await authService.getAccessToken();

  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }

  const clientId = localStorage.getItem('brandId');
  if (clientId) {
    config.params = { ...config.params, clientid: clientId };
  }

  return config;
});

export default surveyClient;
